module.exports = function (blocking) {
  [process.stdout, process.stderr].forEach(function (stream) {
    if (stream._handle && stream.isTTY && typeof stream._handle.setBlocking === 'function') {
      stream._handle.setBlocking(blocking)
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/fsevents/~/set-blocking/index.js
// module id = 2924
// module chunks = 0